import React from "react";
import dayjs from "dayjs";
import ScrollDatePicker from "./ScrollDatePicker";

// Adaptador de ScrollDatePicker para los sitios que usaban
// <input type="date" value="YYYY-MM-DD" onChange={(e) => set(e.target.value)} />.
// Mismo contrato de valor (string "YYYY-MM-DD" o "", en vez de dayjs), para que
// el swap sea mecánico: value/onChange siguen siendo string, solo cambia el
// picker visual (scroll de mes) por el nativo del navegador.
export default function ScrollDateInput({ value, onChange, format = "DD/MM/YYYY", ...rest }) {
  const parsed = value ? dayjs(value, "YYYY-MM-DD") : null;

  return (
    <ScrollDatePicker
      value={parsed && parsed.isValid() ? parsed : null}
      onChange={(d) => onChange?.(d ? d.format("YYYY-MM-DD") : "")}
      format={format}
      {...rest}
    />
  );
}
